module.exports = __webpack_public_path__ + "assets/9745475e5d66c44f36899accd212910d.png";